
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.268 20.087c.622 0 1.22.192 1.731.553a3.026 3.026 0 0 1 .715 4.201c-.922 1.307-2.873 1.65-4.184.718a3.027 3.027 0 0 1-.715-4.201 3.005 3.005 0 0 1 2.453-1.271zm-11.546-3.44a3.004 3.004 0 0 1-2.808-3.181 3.004 3.004 0 0 1 3.18-2.809c.8.05 1.533.408 2.062 1.008.531.601.796 1.372.746 2.173a3.004 3.004 0 0 1-3.18 2.809zM15.585 2.322a2.998 2.998 0 0 1 4.103 1.075c.405.692.516 1.5.312 2.275a2.982 2.982 0 0 1-1.388 1.83c-.46.269-.981.411-1.51.411a3.017 3.017 0 0 1-2.593-1.485 3.007 3.007 0 0 1 1.076-4.106zm1.513 7.502c.866 0 1.72-.233 2.472-.673a4.877 4.877 0 0 0 2.268-2.994 4.891 4.891 0 0 0-.51-3.725A4.923 4.923 0 0 0 17.092 0a4.9 4.9 0 0 0-2.473.672c-2.17 1.273-2.98 3.965-1.986 6.22L7.822 9.71a4.865 4.865 0 0 0-2.615-.96C2.505 8.582.177 10.662.01 13.348c-.166 2.704 1.893 5.04 4.591 5.206a4.838 4.838 0 0 0 2.304-.433l4.743 3.366c-.693 2.012-.04 4.32 1.779 5.608a4.867 4.867 0 0 0 2.83.905c1.59 0 3.087-.776 4.006-2.075a4.922 4.922 0 0 0-1.17-6.846 4.87 4.87 0 0 0-2.83-.903A4.915 4.915 0 0 0 12.6 19.82l-4.075-2.89a4.872 4.872 0 0 0 1.273-2.974 4.874 4.874 0 0 0-.672-2.797l4.595-2.692a4.92 4.92 0 0 0 3.377 1.357z","fill-rule":"evenodd"}})])
          )
        }
      }
    